import { styled } from '@linaria/react';
import { Group, Switch } from '@mantine/core';
import { useGlobalStore } from '../../store/global-store/global-store';
import { setSuperuserMode } from '../../store/global-store/global-store.actions';
import { baseWhite, boxShadowSmallSoft, redDarkest } from '../../styles/design-tokens';
import { Text } from '../../ui-library/typography/typography';

export const SuperuserBar = () => {
  const superuserMode = useGlobalStore((state) => state.superuserMode);

  if (!superuserMode.enabled) {
    return null;
  }

  return (
    <SuperuserBarContainer>
      <Text size="small" weight="medium" color={baseWhite} style={{ paddingLeft: '24px' }}>
        🔴 SUPERUSER MODE ENABLED
      </Text>
      <Group style={{ paddingRight: '24px' }}>
        <Switch
          label="Show Flora model selection"
          checked={superuserMode.showModelSelection}
          onChange={() => {
            setSuperuserMode({ showModelSelection: !superuserMode.showModelSelection });
          }}
        />
        <Switch
          label="Enable Force Recalculation"
          checked={superuserMode.forceRecalculation}
          onChange={() => {
            setSuperuserMode({ forceRecalculation: !superuserMode.forceRecalculation });
          }}
        />
      </Group>
    </SuperuserBarContainer>
  );
};

const SuperuserBarContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 40px;
  background-color: ${redDarkest};
  color: ${baseWhite};
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 9999;
  border-top: 2px solid #b91c1c;
  box-shadow: ${boxShadowSmallSoft};
`;
